import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function AruaMasindiBaseline() {
  return (
    <div className="art-page">
      <SEO
        title="Socio-Economic Study and Energy Access Baseline — Arua and Masindi Districts"
        description="CIRCODU conducted a comprehensive socio-economic and energy access baseline study across Arua and Masindi districts for WWF Uganda, establishing evidence for energy access conditions and development planning."
        keywords="baseline study, energy access, Arua, Masindi, socio-economic, WWF Uganda, energy use patterns, household energy, institutional energy, SME energy, key informant interviews, focus group discussions, market surveys, CIRCODU, energy baseline Uganda, Arua energy access, Masindi energy access, socio-economic study Uganda, WWF energy baseline, household energy use Uganda, institutional energy use Uganda, SME energy use Uganda, key informant interviews Uganda, focus group discussions Uganda, market surveys Uganda"
        url="/Socio-Economic-Study-and-Energy-Access-Baseline-Arua-and-Masindi-Districts"
        datePublished="2017-01-11"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Socio-Economic Study and Energy Access Baseline — Arua and Masindi
              Districts
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              January 11, 2017
            </div>
            <h1 className="art-title">
              Socio-Economic Study and Energy Access Baseline — Arua and Masindi
              Districts
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In late 2016 and early 2017, CIRCODU conducted a combined
                socio-economic and energy access baseline study across{" "}
                <strong>Arua</strong> and <strong>Masindi</strong> districts for{" "}
                <strong>WWF Uganda Country Office</strong>. Arua, situated in
                Uganda's West Nile region bordering South Sudan and the DRC, and
                Masindi, in the mid-western Bunyoro corridor adjacent to
                Murchison Falls National Park, represent contrasting energy
                access environments. Together they provided WWF with a
                geographically diverse picture of household and institutional
                energy use across areas of significant conservation and
                development interest.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU deployed a comprehensive multi-method survey approach
                across both districts:
              </p>
              <ol>
                <li>
                  <strong>400 household surveys</strong> documenting fuel use,
                  cooking technologies, energy expenditure, and household
                  demographics.
                </li>
                <li>
                  <strong>58 institutional surveys</strong> covering schools,
                  hospitals, and police barracks.
                </li>
                <li>
                  <strong>SME and industry surveys</strong> capturing the
                  commercial energy landscape in trading centres.
                </li>
                <li>
                  <strong>Key informant interviews</strong> with local leaders
                  and energy sector actors.
                </li>
                <li>
                  <strong>Focus group discussions</strong> gathering community
                  perspectives on energy access and clean cooking.
                </li>
                <li>
                  <strong>Market surveys</strong> of energy products available
                  in local trading centres.
                </li>
              </ol>
              <p>
                The resulting baseline equipped WWF UCO with district-level
                energy data that could serve as both a planning reference and a
                monitoring benchmark for subsequent programming across two of
                Uganda's energy-vulnerable regions.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's energy baseline studies,
                contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
